import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table, Button } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { assignMetric } from './formData';
import { superAdminAction } from '../../../../_actions';
import AccessData from '../../../../_components/common/AccessData';
import tableSort from '../../../../_components/common/Sort';

class AssignMetricsToOrg extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            assignMetric: false,
            allowAccess: false,
            denyAccess: false,
            updateModalState: false,
            updateMessage: null,
            deleteCompetency: false,
            editCompetency: false,
            sortType: false,
            checkBoxData: [],
            buttonData: [],
            competencyDetailsModal: false,
            analyticsMetricList: '',
            competencyDetails: null,
            navData: [],

            metricDataList: [],
            dropDownMetricList: {},
            currentMetricDropdown: "0",
            metricNameState: '',
            metricValueState: '',
            metricValueTotalState: '0',
            addButtonMetric: true,
            addedRowMetric: [],

            delMetricData: {},
            delMetric: false,

            competencyEditModal: false,
            competencyEditDetails: {},
            metricValueTotalEditState: '0',
            metricNameEditState: '',
            metricValueEditState: '',
            editRemoveLevel: []
        }
    }

    componentDidMount() {
        const { id } = this.props.match.params;

        this.setState({
            orgId: +this.props.match.params.id
        })
        this.props.dispatch(superAdminAction.getMetricsListHandler(() => {
            const fd = {
                'analytics_organisation': id
            }
            this.props.dispatch(superAdminAction.combinedMetricListApi(fd, (response_dropdownMetricList) => {
                this.setState({
                    dropDownMetricList: response_dropdownMetricList.data
                }, () => {
                    this.props.dispatch(superAdminAction.getAnalyticsMetricListHandler(fd, (response_get_metric_list) => {
                        this.setState({
                            metricDataList: response_get_metric_list.data.levels_list,
                            buttonData: response_get_metric_list.data.levels_list.length ? [
                                {
                                    id: 2,
                                    name: 'Edit Level',
                                    toggler: this.onClickEditButtonMetric.bind(this),
                                    togglerModal: this.state.competencyEditModal,
                                    icon: 'fa fa-edit',
                                    disabled: '',
                                    title: 'Edit Level'
                                }
                            ]
                            :
                            [
                                {
                                    id: 1,
                                    name: 'Assign Level',
                                    toggler: this.toggleAllowAccessModal.bind(this),
                                    togglerModal: this.state.allowAccess,
                                    icon: 'fa fa-plus',
                                    disabled: '',
                                    title: 'Assign Level'
                                }
                            ]
                        })
                    }))
                })
            }))

        }))

        this.setState({
            buttonData: [
                {
                    id: 1,
                    name: 'Assign Metric',
                    toggler: this.toggleAllowAccessModal.bind(this),
                    togglerModal: this.state.allowAccess,
                    icon: 'fa fa-plus',
                    disabled: 'disabled',
                    title: 'Assign Metric'
                }
            ]
        })
        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    componentDidUpdate(prevProps, prevState) {
        // getMetricsListResponse, getAnalyticsMetricListResponse
        if (prevProps.getAnalyticsMetricListResponse !== this.props.getAnalyticsMetricListResponse) {
            if (this.props.getAnalyticsMetricListResponse !== '' && this.props.getMetricsListResponse !== '') {
                this.setState({
                    analyticsMetricList: this.props.getMetricsListResponse
                })
            }
        }
        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }


    toggleAllowAccessModal(showModal) {
        this.setState({
            allowAccess: showModal,
            addedRowMetric: [],
            metricValueTotalState: 0
        })
    }

    toggleDenyAccessModal(showModal) {
        this.setState({
            denyAccess: showModal
        })
    }

    toggleEntireAssignMetricModal(showModal) {
        this.setState({
            allowAccess: showModal,
            denyAccess: showModal,
            competencyDetailsModal: showModal,
            addedRowMetric: []
        })
    }

    toggleDelMetric(showModal) {
        this.setState({
            delMetric: showModal
        })
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal,
        });
    }

    compareBy(key) {
        return tableSort(key, this.state.sortType)
    }

    sortBy(columnKey, type) {
        this.setState({ sortType: type })
        let arrayCopy = this.state.metricDataList
        arrayCopy.sort(this.compareBy(columnKey));
        this.setState({ metricDataList: arrayCopy });
    }

    metricDropdownList = (e) => {
        this.setState({
            currentMetricDropdown: e.target.value.split('_')[0],
            currentMetricDropdownType: parseInt(e.target.value.split('_')[1], 10)
        })
    }

    metricNameStateHandler = (e) => {
        this.setState({
            metricNameState: e.target.value
        })
    }

    metricValueStateHandler = (e) => {
        if(/^\d*$/.test(e.target.value)) {
            if( parseInt(e.target.value, 10) <= 10 && parseInt(e.target.value, 10) !== 0 && (parseInt(e.target.value, 10) > parseInt(this.state.metricValueTotalState, 10) || parseInt(e.target.value) === 1)) {
                this.setState({
                    metricValueState: e.target.value
                })
            }else if(e.target.value.length === 0) {
                this.setState({
                    metricValueState: e.target.value
                })
            }
        }
    }

    metricAddValues = () => {
        let addedRowMetric = [...this.state.addedRowMetric]

        addedRowMetric.push({
            metricName: this.state.metricNameState,
            metricValue: +this.state.metricValueState,
            metricStartState: this.state.metricValueTotalState
        })

        let metricValueTotalState = 0

        addedRowMetric.map(val => {
            metricValueTotalState = parseInt(val.metricValue, 10)
        })

        this.setState({
            addedRowMetric,
            metricValueTotalState,
            metricNameState: '',
            metricValueState: '',
        })
    }

    removeIndividualMetric = (pos) => {
        let addedRowMetric = [...this.state.addedRowMetric];

        addedRowMetric.splice(pos, 1)

        let metricValueTotalState = 0

        addedRowMetric.map(val => {
            metricValueTotalState = parseInt(val.metricValue, 10)
        })

        this.setState({
            addedRowMetric,
            metricValueTotalState
        })
    }

    getAccessModalData = (checkBoxData) => {
        let metricDataIdListDefault = [...this.state.metricDataList].filter(metric => metric.anlytics_metric_competency_type === 1).map(metric => metric.metric_id)
        let metricDataIdListOrganisation = [...this.state.metricDataList].filter(metric => metric.anlytics_metric_competency_type === 2).map(metric => metric.metric_id)
        let dropDownMetricList = {...this.state.dropDownMetricList}

        dropDownMetricList.default_competency_metrics = dropDownMetricList.default_competency_metrics.filter(metric => !metricDataIdListDefault.includes(metric.id))
        dropDownMetricList.organisation_competency_metrics = dropDownMetricList.organisation_competency_metrics.filter(metric => !metricDataIdListOrganisation.includes(metric.id))
        const dropDownHeaders = Object.keys(dropDownMetricList)

        return (
            <div>
                {/* <div className="d-flex justify-content-between px-4">
                    <label for="metric_competency_value_dropdown">Select Metric/Competency/Value</label>
                    <select id="metric_competency_value_dropdown" onChange={e => this.metricDropdownList(e)}>
                        <option value="0" selected>{dropDownHeaders.length ? 'Choose an Option' : 'No Data'}</option>
                        {
                            dropDownHeaders.map(header => (
                                dropDownMetricList[header].length ?
                                    <optgroup label={header.split('_')[0].replace(/^\w/, c => c.toUpperCase())}>
                                        {
                                            dropDownMetricList[header].map(val => {
                                                return <option value={`${val.id}_${val.competency_type}`}>{val.competency_metric__competency_name ? val.competency_metric__competency_name : val.assessment_organisation_competency__competency_name}</option>
                                            })
                                        }
                                    </optgroup>
                                :
                                    null
                            ))
                        }
                    </select>
                </div> */}
                <div className="py-2 px-4">
                    <table className="table w-100">
                        <thead style={{background: 'black',color: 'white'}}>
                            <tr>
                                <th>Level Name</th>
                                <th>Start</th>
                                <th>End</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.addedRowMetric.map((val, key) => (
                                    <tr>
                                        <td>{val.metricName}</td>
                                        <td>{val.metricStartState}</td>
                                        <td>{val.metricValue}</td>
                                        <td>
                                            
                                            <Button disabled={!(key === this.state.addedRowMetric.length - 1)} onClick={() => this.removeIndividualMetric(key)}>-</Button>
                                        </td>
                                    </tr>
                                ))
                            }
                            {
                                this.state.metricValueTotalState < 10  ?
                                    <tr>
                                        <td>
                                            <input type="text" value={this.state.metricNameState} onChange={(e) => this.metricNameStateHandler(e)} />
                                        </td>
                                        <td>
                                            {this.state.metricValueTotalState}
                                        </td>
                                        <td>
                                            <input type="text" value={this.state.metricValueState} onChange={(e) => this.metricValueStateHandler(e)} />
                                        </td>
                                        <td>
                                            <Button disabled={!(this.state.metricNameState.length && this.state.metricValueState.length && +this.state.metricValueState > +this.state.metricValueTotalState)} onClick={() => this.metricAddValues()}>+</Button>
                                        </td>
                                    </tr>
                                :
                                    null
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }

    // This method is used to set the checkbox data in state
    getSelectedData(data) {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllAssessment(this.state.checkBoxData, false)
            })
        }
    }

    toggleDetailsCompetency(showModal) {
        this.setState({
            competencyDetailsModal: true,
            competencyDetails: showModal
        })
    }

    selectAllAssessment(data, clickToggle) {
        const { buttonData } = this.state;
        clickToggle === true ?
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        assessmentResponse: data
                    })
                }
            })
            :
            buttonData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        assessmentResponse: data
                    })
                }
            })
    }

    enableAddOrRemove = (checkBoxData, type) => {
        let count = 0;
        for (let i = 0; i < checkBoxData.length; i++) {

            if (checkBoxData[i].access === (type === 'add' ? ' fa fa-check text-success' : ' fa fa-times text-danger')) {


                count = count + 1;
            }
        }
        return count === checkBoxData.length ? false : true;
    }

    onClickEditButtonMetric = () => {

        let metricValueTotalEditState = 0

        this.state.metricDataList.map((val, key) => {
            if(key === this.state.metricDataList.length - 1 ) {
                metricValueTotalEditState = +val.end_value
            }
        })

        this.setState({
            competencyEditModal: true,
            competencyEditDetails: this.state.metricDataList,
            metricValueTotalEditState
        })
        
    }

    removeIndividualMetricEdit = (pos, dataRow) => {
        let competencyEditDetails = {
            metric_values: this.state.metricDataList
        }

        let editRemoveLevel = [...this.state.editRemoveLevel]

        editRemoveLevel.push(dataRow.id)

        competencyEditDetails.metric_values.splice(pos, 1)

        let metricValueTotalEditState = 0

        competencyEditDetails.metric_values.map((val, key) => {
            if(key === competencyEditDetails.metric_values.length - 1 ) {
                metricValueTotalEditState = +val.end_value
            }
        })

        this.setState({
            metricDataList: competencyEditDetails.metric_values,
            competencyEditDetails,
            metricValueTotalEditState,
            editRemoveLevel
        }, () => {
        })
    }

    metricNameEditStateHandler = (e) => {
        this.setState({
            metricNameEditState: e.target.value
        })
    }

    metricValueEditStateHandler = (e) => {
        if(/^\d*$/.test(e.target.value)) {
            if( parseInt(e.target.value, 10) <= 10 && parseInt(e.target.value, 10) !== 0 && (parseInt(e.target.value, 10) > parseInt(this.state.metricValueTotalEditState, 10) || parseInt(e.target.value) === 1)) {
                this.setState({
                    metricValueEditState: e.target.value
                })
            }else if(e.target.value.length === 0) {
                this.setState({
                    metricValueEditState: e.target.value
                })
            }
        }
    }

    metricEditValues = () => {
        let competencyEditDetails = {metricDataList: this.state.metricDataList}

        competencyEditDetails.metricDataList.push({
            level_name: this.state.metricNameEditState,
            end_value: +this.state.metricValueEditState,
            start_value: this.state.metricValueTotalEditState
        })

        let metricValueTotalEditState = 0

        competencyEditDetails.metricDataList.map((val, key) => {
            if(key === competencyEditDetails.metricDataList.length - 1 ) {
                metricValueTotalEditState = +val.end_value
            }
        })

        this.setState({
            competencyEditDetails,
            metricDataList: competencyEditDetails.metricDataList,
            metricValueTotalEditState,
            metricNameEditState: '',
            metricValueEditState: ''
        })
    }

    getCompetencyEdit = () => {
        return (
            <div className="py-2 px-4">
                <table className="table w-100">
                    <thead style={{background: 'black',color: 'white'}}>
                        <tr>
                            <th>Level Name</th>
                            <th>Start</th>
                            <th>End</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.metricDataList.map((val, key) => (
                                <tr>
                                    <td>{val.level_name}</td>
                                    <td>{val.start_value}</td>
                                    <td>{val.end_value}</td>
                                    <td>
                                        <Button disabled={!(key === this.state.metricDataList.length - 1)} onClick={() => this.removeIndividualMetricEdit(key, val)}>-</Button>
                                    </td>
                                </tr>
                            ))
                        }
                        {
                            this.state.metricValueTotalEditState < 10 ?
                                <tr>
                                    <td>
                                        <input type="text" value={this.state.metricNameEditState} onChange={(e) => this.metricNameEditStateHandler(e)} />
                                    </td>
                                    <td>
                                        {this.state.metricValueTotalEditState}
                                    </td>
                                    <td>
                                        <input type="text" value={this.state.metricValueEditState} onChange={(e) => this.metricValueEditStateHandler(e)} />
                                    </td>
                                    <td>
                                        <Button disabled={!(this.state.metricNameEditState.length && this.state.metricValueEditState.length  && +this.state.metricValueEditState > +this.state.metricValueTotalEditState)} onClick={() => this.metricEditValues()}>+</Button>
                                    </td>
                                </tr>
                            :
                                null
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    getCompetencyDetails() {

        const subTable = {
            data: [{
                name: 'Level Name',
                key: 'level_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                color: 'color'

            },
            {
                name: 'Start Name',
                key: 'start_value',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                color: 'color'
            },
            {
                name: 'End Value',
                key: 'end_value',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                color: 'color'
            },]
        }

        const subTableData = []
        this.state.competencyDetails.metric_values.map(
            (data, i) => {
                if (i < this.state.competencyDetails.metric_values.length) {
                    subTableData.push(
                        {
                            level_name: data.level_name,
                            start_value: data.start_value,
                            end_value: data.end_value
                        }
                    )
                }
                // if (i + 1 === this.state.competencyDetails.metric_values.length) {
                //     subTableData.push(
                //         {
                //             attribute__attribute_name: 'Total',
                //             competency_weight: '10',
                //             color: 'rgb(0, 128, 0)'
                //         }
                //     )
                // }
            }
        )

        const returnData =
            <TableNew
                data={subTableData}
                columns={subTable.data}

            />

        return returnData
    }

    actionSelectedAccess = (type) => {
        if (type === 'Add') {

            const level = this.state.addedRowMetric.map(val => {
                return {
                    level_name: val.metricName,
                    start_value: +val.metricStartState,
                    end_value: +val.metricValue
                }
            })

            const fd = {
                "analytics_organisation": +this.props.match.params.id,
                // "type": +this.state.currentMetricDropdownType,
                // "metric_id": +this.state.currentMetricDropdown,
                "level":level
            }

            this.props.dispatch(superAdminAction.addNewCompetency(fd, (response_add_cometency) => {
                this.props.dispatch(superAdminAction.getAnalyticsMetricListHandler( {
                    'analytics_organisation': +this.props.match.params.id
                }, (response_get_metric_list) => {
                    this.setState({
                        buttonData: [
                            {
                                id: 2,
                                name: 'Edit Level',
                                toggler: this.onClickEditButtonMetric.bind(this),
                                togglerModal: this.state.competencyEditModal,
                                icon: 'fa fa-edit',
                                disabled: '',
                                title: 'Edit Level'
                            }
                        ],
                        metricDataList: response_get_metric_list.data.levels_list
                    })
                }))
            }))

        }
        this.setState({
            allowAccess: false,
            denyAccess: false
        })
    }

    actionDelMetric = (type) => {
        if(type === 'Delete') {
            const fd = {
                "analytics_organisation_metric": this.state.delMetricData.metric_id
            }

            this.props.dispatch(superAdminAction.deleteExistingCompetency(fd, (response_del_cometency) => {
                this.props.dispatch(superAdminAction.getAnalyticsMetricListHandler( {
                    'analytics_organisation': +this.props.match.params.id
                }, (response_get_metric_list) => {
                    this.setState({
                        buttonData: [
                            {
                                id: 2,
                                name: 'Edit Level',
                                toggler: this.onClickEditButtonMetric.bind(this),
                                togglerModal: this.state.competencyEditModal,
                                icon: 'fa fa-edit',
                                disabled: '',
                                title: 'Edit Level'
                            }
                        ],
                        metricDataList: response_get_metric_list.data.levels_list
                    })
                }))
            }))

        }
        this.setState({
            delMetric: false
        })
    }

    onClickDelButtonMetric = (data) => {
        this.setState({
            delMetricData: data,
            delMetric: true
        })
    }

    // getReformatTableData = (getMetricsListResponse, getAnalyticsMetricListResponse) => {
    //     let formatedData = []
    //     getMetricsListResponse.map(
    //         (data, i) => {
    //             let count = 0;
    //             for (let i = 0; i < getAnalyticsMetricListResponse.length; i++) {
    //                 if (getAnalyticsMetricListResponse[i].competency_metric__id === data.id) {
    //                     count = count + 1;
    //                 }
    //             }
    //             if (count > 0) {
    //                 formatedData.push({
    //                     ...data,
    //                     // 'rowCheck': true,
    //                     'access': ' fa fa-check text-success',
    //                 })
    //             }
    //             if (count === 0) {
    //                 formatedData.push({
    //                     ...data,
    //                     // 'rowCheck': true,
    //                     'access': ' fa fa-times text-danger',
    //                 })
    //             }
    //         }
    //     )
    //     return formatedData
    // }

    competencyEditAction = (type) => {
        if(type === 'Save Changes') {
            const level = this.state.metricDataList.map(val => {
                return {
                    level_name: val.level_name,
                    start_value: +val.start_value,
                    end_value: +val.end_value
                }
            })

            const fd = {
                "analytics_organisation": +this.props.match.params.id,
                // "metric_id": +this.state.competencyEditDetails.metric_id,
                // "remove_level":this.state.editRemoveLevel,
                "level":level
            }
            this.props.dispatch(superAdminAction.editExistingCompetency(fd, (response_edit_competency) => {
                this.props.dispatch(superAdminAction.getAnalyticsMetricListHandler({
                    'analytics_organisation': +this.props.match.params.id
                }, (response_get_metric_list) => {
                    this.setState({
                        metricDataList: response_get_metric_list.data.levels_list
                    })
                }))
            }))
        }
        this.setState({ competencyEditModal: false, editRemoveLevel: [] })
    }

    AssignMetricDefineLevelValidateState = () => {
        return this.state.metricValueTotalState === 10
    }

    AssignMetricDefineLevelEditValidateState = () => {
        return this.state.metricValueTotalEditState === 10 && this.state.editRemoveLevel.length
    }

    render() {

        const { getMetricsListResponse, getAnalyticsMetricListResponse } = this.props;

        const tables = {
            Team: [{
                name: 'Level Name',
                key: 'level_name',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: '',
                rowCheck: 'rowCheck'


            },{
                name: 'Start Value',
                key: 'start_value',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            }, {
                name: 'End Value',
                key: 'end_value',
                link: '',
                sort: true,
                type: 'text',
                content: '',
                alignCenter: false,
                link: ''
            },
            // {
            //     name: 'Details',
            //     key: 'DETAILS',
            //     link: '',
            //     sort: false,
            //     type: 'Button',
            //     content: 'Details',
            //     alignCenter: false,
            //     link: '',
            //     title: 'Details'
            // },{
            //     name: 'Edit',
            //     key: 'EDIT',
            //     link: '',
            //     sort: false,
            //     type: 'Button',
            //     content: 'EDIT',
            //     alignCenter: false,
            //     link: '',
            //     title: 'Details'
            // },{
            //     name: 'Delete',
            //     key: 'DELETE',
            //     link: '',
            //     sort: false,
            //     type: 'Button',
            //     content: 'Delete',
            //     alignCenter: false,
            //     link: '',
            //     title: 'Details'
            // },
            ]
        }


        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <h5 className="jumbo">ASSIGN METRICS</h5>
                        <UtilityNav
                            actionButtons={this.state.buttonData}
                            modal={this.toggleModal.bind(this)}
                            showModal={this.state.modal}
                        />
                        {
                            (getAnalyticsMetricListResponse !== '' && getMetricsListResponse !== '') &&
                            <TableNew
                                data={this.state.metricDataList}
                                columns={tables.Team}
                                onClickDetailsButton={this.toggleDetailsCompetency.bind(this)}
                                onClickDelButton={this.onClickDelButtonMetric.bind(this)}
                                onClickEditButton={this.onClickEditButtonMetric.bind(this)}
                                // checkbox="true"
                                selectCheckBox={this.selectAllAssessment.bind(this)}
                                getData={this.getSelectedData.bind(this)}
                                CheckKey={"id"}
                                sortBy={(key) => this.sortBy(key, !this.state.sortType)}
                                sortType={this.state.sortType}

                            />
                        }

                        {
                            (getAnalyticsMetricListResponse === '' || getMetricsListResponse === '') &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                &nbsp;Loading</p>
                        }

                        {
                            this.state.allowAccess &&
                            <ModalComponent
                                showModal={this.state.allowAccess}
                                heading="Assign Metric and Define Levels"
                                // formData={paUserPermissions}
                                // action={this.actionSelectedAccess.bind(this)}
                                htmlTag={this.getAccessModalData(this.state.checkBoxData)}
                                toggleEntireModal={this.toggleEntireAssignMetricModal.bind(this)}
                                footerNonSubmitButton={this.AssignMetricDefineLevelValidateState()
                                ?
                                [{
                                    'buttonName': 'Add',
                                },{
                                    'buttonName': 'Cancel',
                                }]
                                :
                                [{
                                    'buttonName': 'Cancel',
                                }]}
                                selectKey={['permission_id']}
                                selects={['permission_name']}
                                responseHandler={(type) => this.actionSelectedAccess(type)}

                            />
                        }

                        {
                            this.state.delMetric &&
                            <ModalComponent
                                showModal={this.state.delMetric}
                                heading={"Delete Metric - "+this.state.delMetricData.competency_metric_name}
                                // formData={paUserPermissions}
                                // action={this.actionSelectedAccess.bind(this)}
                                htmlTag={<p>Are you sure?</p>}
                                toggleEntireModal={this.toggleDelMetric.bind(this)}
                                footerNonSubmitButton={
                                [{
                                    'buttonName': 'Delete',
                                },{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.actionDelMetric(type)}

                            />
                        }

                        {
                            this.state.denyAccess &&
                            <ModalComponent
                                showModal={this.state.denyAccess}
                                heading="Deny Access"
                                // formData={paUserPermissions}
                                // action={this.actionSelectedDenyAccess.bind(this)}
                                htmlTag={this.getAccessModalData(this.state.checkBoxData)}
                                toggleEntireModal={this.toggleEntireAssignMetricModal.bind(this)}
                                footerNonSubmitButton={this.enableAddOrRemove(this.state.checkBoxData, 'remove') ? [{
                                    'buttonName': 'Remove',
                                }, {
                                    'buttonName': 'Cancel',
                                }] : [{
                                    'buttonName': 'Cancel',
                                }]}
                                selectKey={['permission_id']}
                                selects={['permission_name']}
                                responseHandler={(type) => this.actionSelectedAccess(type)}
                            />
                        }

                        {
                            this.state.competencyDetailsModal &&
                            <ModalComponent
                                showModal={this.state.competencyDetailsModal}
                                heading={'Competency - '+this.state.competencyDetails.competency_metric_name}
                                toggleEntireModal={this.toggleEntireAssignMetricModal.bind(this)}
                                htmlTag={this.getCompetencyDetails()}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => { this.setState({ competencyDetailsModal: false }) }}
                            />
                        }
                        {
                            this.state.competencyEditModal &&
                            <ModalComponent
                                showModal={this.state.competencyEditModal}
                                heading={'Levels Edit'}
                                toggleEntireModal={this.toggleEntireAssignMetricModal.bind(this)}
                                htmlTag={this.getCompetencyEdit()}
                                footerNonSubmitButton={this.AssignMetricDefineLevelEditValidateState() ?[{
                                    'buttonName': 'Save Changes'
                                },{
                                    'buttonName': 'Cancel',
                                }]
                                :
                                [{
                                    'buttonName': 'Cancel',
                                }]}
                                responseHandler={(type) => this.competencyEditAction(type)}
                            />
                        }

                        {
                            this.state.updateModalState &&
                            <ModalComponent
                                showModal={this.state.updateModalState}
                                heading={this.state.updateMessage.heading}
                                headerColor={this.state.updateMessage.headerColor}
                                headingIcon={this.state.updateMessage.headingIcon}
                                toggleEntireModal={() => this.setState({ updateModalState: false })}
                                htmlText={this.state.updateMessage.text}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ updateModalState: false })}
                            />
                        }
                    </div>

                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { getMetricsListLoading } = state.getMetricsListReducer;
    const getMetricsListError = state.getMetricsListReducer.error;
    const getMetricsListResponse = (!getMetricsListLoading && !getMetricsListError) ? state.getMetricsListReducer.data.data.competency_metrics : '';

    const { getAnalyticsMetricListLoading } = state.getAnalyticsMetricListReducer;
    const getAnalyticsMetricListError = state.getAnalyticsMetricListReducer.error;
    const getAnalyticsMetricListResponse = (!getAnalyticsMetricListLoading && !getAnalyticsMetricListError) ? state.getAnalyticsMetricListReducer.data.data.competency_metrices : '';

         //Header Permission
         const { headPerLoading } = state.headerPermissionReducer
         const headPerLoadingError = state.headerPermissionReducer.error
         const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

    return {
        getMetricsListResponse,
        getAnalyticsMetricListResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(AssignMetricsToOrg);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/AssignMetricsToOrg/index.js